import { gsap } from 'gsap'
import DrawSVGPlugin from 'gsap/DrawSVGPlugin'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(DrawSVGPlugin)
gsap.registerPlugin(ScrollTrigger)

gsap.set('.animation-line path', { drawSVG:"100% 100%" })

gsap.utils.toArray('.animate-line-scroll').forEach(element => {

  ScrollTrigger.create({
    trigger: element,
    start: 'top center',
    end: 'center center',
    scrub: true,
    //markers: true,
    once: true,
    onEnter: () => {
      let path = $(element).find('path')

      let tl = gsap.timeline({ paused: true, repeat: 0, yoyo: false })
      tl.fromTo(path, { drawSVG:"100% 100%" }, { duration: 1.5, drawSVG: "0% 100%", delay: 0.1, stagger: 0.1 })

      if($(element).hasClass('animation-line-footer')) {
        tl.play()
      } else {
        tl.play()
      }

    }
  })

})
